import React, { Component } from 'react';

import { base } from '../../base';

import BrandItem from './BrandItem';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import Fuse from 'fuse.js';

import './Brand.css';

class Brand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      addItemModal: false,
      brandItem: {}
    };
  }

  componentDidMount() {
    this.resetState();
  }

  resetState() {
    this.setState({
      productList: this.props.brandItems,
      addItemModal: false,
      searchTerm: '',
      brandItem: {}
    });
  }

  onOpenModal = () => {
    this.setState({
      addItemModal: true
    });
  };

  onCloseModal = () => {
    this.resetState();
  };

  onChangeField = (val, key) => {
    this.setState(currentState => {
      const newState = Object.assign({}, currentState);
      newState.brandItem[key] = val;
      return newState;
    });
  };

  onSubmitUser = () => {
    base
      .addToCollection('hardware', { ...this.state.brandItem })
      .then(() => {
        this.resetState();
        window.alert('Success!');
      })
      .catch(err => {
        console.log(err);
        window.alert('See console for error report');
      });
  };

  onSearch = searchTerm => {
    if (searchTerm === '') {
      this.resetState();
      return;
    }

    const options = {
      caseSensitive: false,
      shouldSort: true,
      threshold: 0.3, // magic number to play with
      maxPatternLength: 24,
      minMatchCharLength: 2,
      keys: ['id', 'model', 'type', 'promoted', 'version']
    };

    const fuse = new Fuse(this.props.brandItems, options);
    this.setState({
      searchTerm,
      productList: fuse.search(searchTerm)
    });
  };

  render() {
    const { searchTerm, productList, addItemModal } = this.state;
    const variant = 'outlined';

    return (
      <div className="brand">
        <TextField
          className="search"
          value={searchTerm}
          onChange={e => this.onSearch(e.target.value)}
          placeholder="Search..."
        />

        <Button
          variant="fab"
          color="secondary"
          className="add-button"
          onClick={this.onOpenModal}
        >
          <Icon>add</Icon>
        </Button>

        <Grid container={true} spacing={8}>
          {productList &&
            productList.map(brandItem => (
              <Grid key={brandItem.id} item={true} xs={12} sm={6} md={4}>
                <BrandItem brandItem={brandItem} />
              </Grid>
            ))}
        </Grid>

        {addItemModal && (
          <Modal open={addItemModal} onClose={this.onCloseModal}>
            <div className="add-user-modal">
              <Grid className="content" container={true} spacing={8}>
                <Button onClick={this.onSubmitUser}>add item</Button>
                <Grid xs={12} item={true}>
                  <FormControlLabel
                    control={
                      <Switch
                        onChange={(e, checked) =>
                          this.onChangeField(checked, 'promoted')
                        }
                        checked={this.state.brandItem.promoted ? true : false}
                      />
                    }
                    label="Promoted"
                  />
                  <div className="field">
                    <TextField
                      value={this.state.brandItem.brand || ''}
                      label="Brand"
                      variant={variant}
                      onChange={e =>
                        this.onChangeField(e.target.value, 'brand')
                      }
                    />
                  </div>
                  <div className="field">
                    <TextField
                      value={this.state.brandItem.model || ''}
                      label="Model"
                      variant={variant}
                      onChange={e =>
                        this.onChangeField(e.target.value, 'model')
                      }
                    />
                  </div>
                  <div className="field">
                    <TextField
                      value={this.state.brandItem.version || ''}
                      label="Version"
                      variant={variant}
                      onChange={e =>
                        this.onChangeField(e.target.value, 'version')
                      }
                    />
                  </div>
                  <div className="field">
                    <TextField
                      value={this.state.brandItem.link || ''}
                      label="Link"
                      variant={variant}
                      onChange={e => this.onChangeField(e.target.value, 'link')}
                    />
                  </div>
                  <div className="field">
                    <TextField
                      value={this.state.brandItem.imgSource || ''}
                      label="Image Source"
                      variant={variant}
                      onChange={e =>
                        this.onChangeField(e.target.value, 'imgSource')
                      }
                    />
                  </div>
                  <div className="field">
                    <TextField
                      value={this.state.brandItem.price || ''}
                      label="Price"
                      variant={variant}
                      onChange={e =>
                        this.onChangeField(e.target.value, 'price')
                      }
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default Brand;



// WEBPACK FOOTER //
// ./src/components/Hardware/Brand.js